module.exports = __webpack_public_path__ + "img/myinvestor-dark.ee651b2c.png";